import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames/bind'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faChevronDown,
    faChevronUp,
    faLock,
} from '@fortawesome/free-solid-svg-icons'
import {
    faInfoCircle,
    faLightbulbOn,
} from '@fortawesome/pro-light-svg-icons'
import styles from './AnalysisBox.module.css'
import Button from '../Button/Button'
import { Tooltip } from 'react-tippy'

let cx = classNames.bind(styles)

class AnalysisBox extends React.Component {
    state = {
        readingEaseIsOpen: false,
        readingTimeIsOpen: false,
        FemaleWordisOpen: false,
        MaleWordisOpen: false,
        wordCountSectionIsOpen: false,
    }

    toggleReadingEaseDetail = () => {
        this.setState({
            readingEaseIsOpen: !this.state.readingEaseIsOpen,
        })
    }

    toggleReadingTimeDetail = () => {
        this.setState({
            readingTimeIsOpen: !this.state.readingTimeIsOpen,
        })
    }

    toggleMaleWordDetail = () => {
        if (!this.props.user.userId) {
            return
        }
        this.setState({
            MaleWordisOpen: !this.state.MaleWordisOpen,
        })
    }

    toggleFemaleWordDetail = () => {
        if (!this.props.user.userId) {
            return
        }
        this.setState({
            FemaleWordisOpen: !this.state.FemaleWordisOpen,
        })
    }

    toggleWordCountSectionDetail = () => {
        this.setState({
            wordCountSectionIsOpen: !this.state.wordCountSectionIsOpen,
        })
    }

    processReadingTime = wordCount => {
        const minsToRead = wordCount / 200
        if (minsToRead === 0) {
            return `NA`
        } else if (minsToRead < 1) {
            return `< 1`
        } else {
            return `${Math.ceil(minsToRead)}`
        }
    }
    readingEaseMoreDetail = (score, isEmpty) => {
        let boundedScore
        if (score > 100) {
            boundedScore = 100
        } else if (score < 0) {
            boundedScore = 0
        } else {
            boundedScore = Math.round(score)
        }
        if (isEmpty) {
            return (
                <div>
                    <p>
                        Using sesquipedalian words in labyrinthine sentences
                        merely obfuscates what you're trying to communicate...
                        (see what I mean).
                    </p>
                    <p>
                        Your best hire might be busy, distracted, or reading it
                        on a small device. Keep it simple.
                    </p>
                </div>
            )
        } else if (score > 90) {
            return (
                <div>
                    <p className={styles.readDetails}>
                        <div>
                            <strong>Reading Level:</strong> Comic book or kids
                            book
                        </div>
                        <div>
                            <strong>Score:</strong> {boundedScore}
                        </div>
                    </p>
                </div>
            )
        } else if (score > 70) {
            return (
                <div>
                    <p className={styles.readDetails}>
                        <div>
                            <strong>Score:</strong> {boundedScore}
                        </div>
                        <div>
                            <strong>Reading Level:</strong> Harry Potter books
                        </div>
                    </p>
                </div>
            )
        } else if (score > 60) {
            return (
                <div>
                    <p className={styles.readDetails}>
                        <div>
                            <strong>Score:</strong> {boundedScore}
                        </div>
                        <div>
                            <strong>Reading Level:</strong> Time magazine
                        </div>
                    </p>
                </div>
            )
        } else if (score > 40) {
            return (
                <div>
                    <div className={styles.readDetails}>
                        <div>
                            <strong>Reading Level:</strong> Financial Times
                        </div>
                        <div>
                            <strong>Score:</strong> {boundedScore}
                        </div>
                    </div>
                    <p>
                        Your best hire might be busy, distracted, or reading it
                        on a small device. Keep it simple.
                    </p>
                </div>
            )
        } else if (score > 30) {
            return (
                <div>
                    <p className={styles.readDetails}>
                        <div>
                            <strong>Reading Level:</strong> Shakespeare
                        </div>
                        <div>
                            <strong>Score:</strong> {boundedScore}
                        </div>
                    </p>
                    <p>
                        Your best hire might be busy, distracted, or reading it
                        on a small device. Keep it simple.
                    </p>
                </div>
            )
        } else if (score > 20) {
            return (
                <div>
                    <p className={styles.readDetails}>
                        <div>
                            <strong>Reading Level:</strong> Harvard Law Review
                        </div>
                        <div>
                            <strong>Score:</strong> {boundedScore}
                        </div>
                    </p>
                    <p>
                        Your best hire might be busy, distracted, or reading it
                        on a small device. Keep it simple.
                    </p>
                </div>
            )
        } else {
            return (
                <div>
                    <p className={styles.readDetails}>
                        <div>
                            <strong>Reading Level:</strong> Hardcore academic
                            literature
                        </div>
                        <div>
                            <strong>Score:</strong> {boundedScore}
                        </div>
                    </p>
                    <p>
                        Your best hire might be busy, distracted, or reading it
                        on a small device. Keep it simple.
                    </p>
                </div>
            )
        }
    }

    genderBiasMoreDetail = (score, isEmpty) => {
        let message = ''
        if (isEmpty || score === undefined) {
            message = "We unconsciously associate some words with gender, and research shows that too many gender-coded words can turn people away. Aim for a neutral, or feminine-coded job description (as men typically aren't impacted)."
        } else if (score === 0) {
            message = 'Far out 🎉 - a neutrally coded job description will help make your job appeal to more people!'
        } else if (score > 0) {
            message = 'Your job description has masculine coded words, these will put off women from applying to the job 😫'
        } else if (score < 0) {
            message = "Far out 🎉 - a feminine coded job description will help make your job appeal to more people! Fun fact: studies show that feminine coding doesn't put off men so... you're all good!"
        }

        return (<div className={styles.popover}>{message}</div>)
    }

    inclusionPopover = () => {
        return (
            <div className={styles.popover}>
                <div>These factors help to make your job appeal to a broader audience.</div>
            </div>
        )
    }

    experiencePopover = () => {
        return (
            <div className={styles.popover}>
                If you put too much weight on 'proven'
                experience you prevent fresh talent from
                competing for the role. Experience is just
                one of many indicators, but can allow
                historic biases to persist.</div>
        )
    }

    mustPopover = () => {
        return (
            <div className={styles.popover}>Mandating requirements using "must" reduces
                applications from under-represented groups.</div>
        )
    }

    educationPopover = () => {
        return (
            <div className={styles.popover}>Educational attainment isn't strongly
                predictive of performance in a role, and
                requiring it means inheriting bias. Be sure
                to only require education &amp;
                qualifications that are actually necessary.</div>
        )
    }

    buzzwordPopover = () => {
        return (
            <div className={styles.popover}>Buzzwords put off applicants by making your
                company feel cold and uninviting. Write like a human.</div>
        )
    }

    acronymsPopover = () => {
        return (
            <div className={styles.popover}>Acronyms are an artificial barrier.
                Familiarity helps those that are just familiar but hinders those that are just able.</div>
        )
    }

    render() {
        return (
            <div className={styles.flexWrapper}>
                <div className={cx('card', 'inclusionScoreCard')}>
                <div className={cx('flexRow', 'titleRow', 'noClick')}>
                    <div className={styles.bigTitle}>Inclusion score</div>
                    <Tooltip
                        html={this.inclusionPopover()}
                        interactive
                        position={'bottom'}
                        theme={'light'}
                    >
                        <FontAwesomeIcon
                            icon={faInfoCircle}
                            className={styles.greyIcon}
                        />
                    </Tooltip>
                    <div
                        className={cx({
                            mainScore: true,
                            emptyMetric: this.props.editorEmpty,
                            excellentMetric:
                                this.props.inclusionScore >= 85 &&
                                !this.props.editorEmpty,
                            goodMetric:
                                this.props.inclusionScore >= 70 &&
                                this.props.inclusionScore < 85,
                            mediumMetric:
                                this.props.inclusionScore >= 50 &&
                                this.props.inclusionScore < 70,
                            belowAverageMetric:
                                this.props.inclusionScore >= 30 &&
                                this.props.inclusionScore < 50,
                            badMetric:
                                this.props.inclusionScore < 30 &&
                                !this.props.editorEmpty,
                        })}
                    >
                        <div>
                            {this.props.editorEmpty
                                ? 'NA'
                                : `${this.props.inclusionScore} / 100` }
                        </div>
                    </div>
                </div>
                <div className={styles.blurParent}>
                    <div
                        className={cx({
                            blurIt: !this.props.user.userId,
                            container: true,
                        })}
                    >
                            <div
                                className={cx({
                                    rowWrapper: true,
                                    typeTitle: true,
                                })}
                            >
                                <div className={styles.weirdRowWrapThing}>
                                    <span
                                        className={cx({
                                            metric: true,
                                            experience: true,
                                            emptyMetric:
                                                this.props.countExperience === 0,
                                        })}
                                    >
                                        {this.props.countExperience}
                                    </span>
                                </div>
                                <div
                                    className={cx({
                                        rowLabel: true,
                                        disabled: this.props.countExperience === 0
                                    })}
                                >
                                    Inhibiting fresh talent
                                </div>
                                <Tooltip
                                    html={this.experiencePopover()}
                                    interactive
                                    position={'bottom'}
                                    theme={'light'}
                                    className={styles.pushRight}
                                >
                                    <FontAwesomeIcon
                                        icon={faLightbulbOn}
                                        className={styles.blueIcon}
                                    />
                                </Tooltip>
                            </div>
                            <div
                                className={cx({
                                    rowWrapper: true,
                                    typeTitle: true,
                                })}
                            >
                                <div className={styles.weirdRowWrapThing}>
                                    <span
                                        className={cx({
                                            metric: true,
                                            must: true,
                                            emptyMetric:
                                                this.props.mustCount === 0,
                                        })}
                                    >
                                        {this.props.mustCount}
                                    </span>
                                </div>
                                <div
                                    className={cx({
                                        rowLabel: true,
                                        disabled: this.props.mustCount === 0,
                                    })}
                                >
                                    Must have requirements</div>
                                <Tooltip
                                    html={this.mustPopover()}
                                    interactive
                                    position={'bottom'}
                                    theme={'light'}
                                    className={styles.pushRight}
                                >
                                    <FontAwesomeIcon
                                        icon={faLightbulbOn}
                                        className={styles.blueIcon}
                                    />
                                </Tooltip>
                            </div>
                            <div
                                className={cx({
                                    rowWrapper: true,
                                    typeTitle: true,
                                })}
                            >
                                <div className={styles.weirdRowWrapThing}>
                                    <span
                                        className={cx({
                                            metric: true,
                                            education: true,
                                            emptyMetric:
                                                this.props.countEducation === 0,
                                        })}
                                    >
                                        {this.props.countEducation}
                                    </span>
                                </div>
                                <div
                                    className={cx({
                                        rowLabel: true,
                                        disabled: this.props.countEducation === 0
                                    })}
                                >
                                    Over-emphasis on education</div>
                                <Tooltip
                                    html={this.educationPopover()}
                                    interactive
                                    position={'bottom'}
                                    theme={'light'}
                                    className={styles.pushRight}
                                >
                                    <FontAwesomeIcon
                                        icon={faLightbulbOn}
                                        className={styles.blueIcon}
                                    />
                                </Tooltip>
                            </div>
                        <div
                            className={cx({
                                flexRow: true,
                                analysisType: true,
                            })}
                            onClick={this.toggleFemaleWordDetail}
                        >
                            <div
                                className={cx({
                                    rowWrapper: true,
                                })}
                            >
                                <span className={cx({
                                    feminine: true, metric: true,
                                    emptyMetric:
                                        this.props.femaleCount === 0})
                                }>
                                    {this.props.femaleCount}
                                </span>
                                <span
                                    className={cx({
                                        rowLabel: true,
                                        disabled: this.props.femaleCount === 0
                                    })}
                                >
                                    Feminine coded words</span>
                                <div className={cx({weirdRowWrapThing: true, pushRight: true})}>
                                    {this.props.user.userId ? (
                                        <div className={styles.chevronWrap}>
                                            <FontAwesomeIcon
                                                icon={
                                                    this.state.FemaleWordisOpen
                                                        ? faChevronUp
                                                        : faChevronDown
                                                }
                                            />
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                            {this.state.FemaleWordisOpen ? (
                                <div
                                    className={cx({
                                        extraData: true,
                                        padPad: true,
                                        explainer: true,
                                    })}
                                >
                                    {this.props.femaleWords.length > 0 ? (
                                        this.props.femaleWords.map((word, i) => {
                                            // eslint-disable-next-line
                                            return (
                                                <span
                                                    key={i}
                                                    className={cx({
                                                        genderedword: true,
                                                        feminine: true,
                                                    })}
                                                    // className={styles.genderedword}
                                                >
                                            {word.word.replace(
                                                /\b[-.,()&$#!\[\]{}"']+\B|\b[...]+\B|\B[-.,()&$#!\[\]{}"']+\b/g, // eslint-disable-line no-useless-escape
                                                '',
                                            )}
                                        </span>
                                            )
                                        })
                                    ) : (
                                        <span
                                            className={cx({
                                                extraData: true,
                                                // padPad: true,
                                                explainer: true,
                                            })}
                                        >
                                    Looks like you've got no feminine-coded
                                    words!
                                </span>
                                    )}
                                </div>
                            ) : null}
                        </div>
                        <div
                            className={cx({
                                flexRow: true,
                                analysisType: true,
                            })}
                            onClick={this.toggleMaleWordDetail}
                        >
                            <div
                                className={cx({
                                    rowWrapper: true,
                                })}
                            >
                                <span className={cx({
                                    masculine: true,
                                    metric: true,
                                    emptyMetric:
                                        this.props.maleCount === 0,})}>
                                    {this.props.maleCount}
                                </span>
                                <span
                                    className={cx({
                                        rowLabel: true,
                                        disabled: this.props.maleCount === 0
                                    })}
                                >
                                    Masculine coded words</span>
                                <div className={cx({weirdRowWrapThing: true, pushRight: true})}>
                                    {this.props.user.userId ? (
                                        <div className={styles.chevronWrap}>
                                            <FontAwesomeIcon
                                                icon={
                                                    this.state.MaleWordisOpen
                                                        ? faChevronUp
                                                        : faChevronDown
                                                }
                                            />
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                            {this.state.MaleWordisOpen ? (
                                <div
                                    className={cx({
                                        extraData: true,
                                        padPad: true,
                                        explainer: true,
                                    })}
                                >
                                    {this.props.maleWords.length > 0 ? (
                                        this.props.maleWords.map((word, i) => {
                                            return (
                                                <span
                                                    key={i}
                                                    className={cx({
                                                        genderedword: true,
                                                        masculine: true,
                                                    })}
                                                >
                                            {word.word.replace(
                                                /\b[-.,()&$#!\[\]{}"']+\B|\b[\u2026]+\B|\B[-.,()&$#!\[\]{}"']+\b/g, // eslint-disable-line no-useless-escape
                                                '',
                                            )}
                                        </span>
                                            )
                                        })
                                    ) : (
                                        <span
                                            className={cx({
                                                extraData: true,
                                                explainer: true,
                                            })}
                                        >
                                    Looks like you've got no masculine-coded
                                    words!
                                </span>
                                    )}
                                </div>
                            ) : null}
                        </div>
                        <div
                            className={cx({
                                rowWrapper: true,
                                typeTitle: true,
                                rowExtraPadding: true,
                            })}
                        >
                            <span className={styles.bigTitle}>Avg. Gender coding</span>
                            <Tooltip
                                html={this.genderBiasMoreDetail(
                                        this.props.score,
                                        this.props.editorEmpty,
                                    )}
                                interactive
                                position={'bottom'}
                                theme={'light'}
                            >
                                <FontAwesomeIcon
                                    icon={faInfoCircle}
                                    className={styles.greyIcon}
                                />
                            </Tooltip>
                            <div className={cx({weirdRowWrapThing: true, pushRight: true})}>
                                <span
                                    className={cx({
                                        metric: true,
                                        bigMetric: true,
                                        genderMetric: true,
                                        emptyMetric: this.props.editorEmpty,
                                        feminine: this.props.bias.score < 0 && !this.props.editorEmpty,
                                        masculine: this.props.bias.score > 0 && !this.props.editorEmpty,
                                        mediumMetric: this.props.bias.score === 0 && !this.props.editorEmpty,
                                    })}
                                >
                                    {this.props.editorEmpty ? 'NA' : this.props.bias.description}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                    {!this.props.user.userId ? (
                        <div className={styles.padlockSection}>
                            <FontAwesomeIcon
                                icon={faLock}
                                className={styles.deactivatedLock}
                            />
                        </div>
                    ) : null}
                </div>

                <div className={cx('card', 'conversionCard')}>
                    <div className={cx('flexRow', 'titleRow', 'noClick')}>
                        <div>
                            <div className={styles.bigTitle}>Conversion</div>
                        </div>
                        <div
                            className={cx({
                                mainScore: true,
                                goodMetric:
                                    this.props.conversionScore >= 80 &&
                                    !this.props.editorEmpty,
                                mediumMetric:
                                    this.props.conversionScore < 80 &&
                                    this.props.conversionScore >= 40 &&
                                    !this.props.editorEmpty,
                                badMetric:
                                    this.props.conversionScore < 40 &&
                                    !this.props.editorEmpty,
                                emptyMetric: this.props.editorEmpty,
                            })}
                        >
                            <div>
                                {this.props.editorEmpty
                                    ? 'NA'
                                    : `${this.props.conversionScore} / 100` }
                            </div>
                        </div>
                    </div>
                    <div className={styles.blurParent}>
                        <div
                            className={cx({
                                blurIt: !this.props.user.userId,
                            })}
                        >
                            <div
                                className={cx({
                                    flexRow: true,
                                    analysisType: true,
                                })}
                                onClick={this.toggleReadingTimeDetail}
                            >
                                <div
                                    className={cx({
                                        rowWrapper: true,
                                        typeTitle: true,
                                    })}
                                >
                                    <span
                                        className={cx({
                                            metric: true,
                                            emptyMetric:
                                                this.props.wordCount === 0,
                                            badMetric:
                                                (this.props.wordCount < 300
                                                    && this.props.wordCount > 0) ||
                                                this.props.wordCount > 800,
                                            goodMetric:
                                                this.props.wordCount > 300 &&
                                                this.props.wordCount < 800,
                                        })}
                                    >
                                            {this.props.wordCount === 0 ? (
                                                <span>0</span>
                                            ) : (
                                                this.processReadingTime(
                                                    this.props.wordCount,
                                                )
                                            )}
                                        </span>
                                    <span
                                        className={cx({
                                            rowLabel: true,
                                            disabled: this.props.wordCount === 0
                                        })}
                                    >
                                        Time to read (minutes)</span>
                                    <div className={cx('weirdRowWrapThing', 'pushRight')}>
                                        <div className={styles.chevronWrap}>
                                            <FontAwesomeIcon
                                                icon={
                                                    this.state.readingTimeIsOpen
                                                        ? faChevronUp
                                                        : faChevronDown
                                                }
                                            />
                                        </div>
                                    </div>
                                </div>
                                {this.state.readingTimeIsOpen ? (
                                    <div
                                        className={cx({
                                            extraData: true,
                                            explainer: true,
                                        })}
                                    >
                                        <div>
                                            Give candidates enough context but don’t make your Job ad too long. Ads that take 2-3 minutes to read perform the best - the perfect balance of detail and brevity.
                                        </div>
                                    </div>
                                ) : null}
                            </div>

                            <div
                                className={cx({
                                    flexRow: true,
                                    analysisType: true,
                                })}
                                onClick={this.toggleReadingEaseDetail}
                            >
                                <div
                                    className={cx({
                                        rowWrapper: true,
                                        typeTitle: true,
                                    })}
                                >
                                    <span
                                        className={cx({
                                            metric: true,
                                            badMetric:
                                                this.props.wordCount &&
                                                this.props.readingEase < 30,
                                            belowAverageMetric:
                                                this.props.wordCount &&
                                                this.props.readingEase >= 30 &&
                                                this.props.readingEase < 50,
                                            mediumMetric:
                                                this.props.readingEase >= 50 &&
                                                this.props.readingEase < 70,
                                            goodMetric:
                                                this.props.readingEase >= 70 &&
                                                this.props.readingEase < 85,
                                            excellentMetric:
                                                this.props.readingEase >= 85,
                                            emptyMetric:
                                                this.props.wordCount === 0,
                                        })}
                                    >
                                            {this.props.wordCount === 0 ? (
                                                <span>0</span>
                                            ) : null}
                                        {this.props.wordCount > 0 &&
                                        this.props.readingEase < 40 ? (
                                            <span>High</span>
                                        ) : null}
                                        {this.props.wordCount > 0 &&
                                        this.props.readingEase > 40 &&
                                        this.props.readingEase < 60 ? (
                                            <span>Mid</span>
                                        ) : null}
                                        {this.props.wordCount > 0 &&
                                        this.props.readingEase > 60 ? (
                                            <span>Low</span>
                                        ) : null}
                                        </span>
                                    <span
                                        className={cx({
                                            rowLabel: true,
                                            disabled: this.props.wordCount === 0
                                        })}
                                    >
                                        Reading burden</span>
                                    <div className={cx('weirdRowWrapThing', 'pushRight')}>
                                        <div className={styles.chevronWrap}>
                                            <FontAwesomeIcon
                                                icon={
                                                    this.state.readingEaseIsOpen
                                                        ? faChevronUp
                                                        : faChevronDown
                                                }
                                            />
                                        </div>
                                    </div>
                                </div>

                                {this.state.readingEaseIsOpen ? (
                                    <div
                                        className={cx({
                                            extraData: true,
                                            explainer: true,
                                        })}
                                    >
                                        <div>
                                            {this.readingEaseMoreDetail(
                                                this.props.readingEase,
                                                this.props.editorEmpty,
                                            )}
                                        </div>
                                    </div>
                                ) : null}
                            </div>
                            <div
                                className={cx({
                                    flexRow: true,
                                    analysisType: true,
                                })}
                                onClick={this.toggleWordCountSectionDetail}
                            >
                                <div
                                    className={cx({
                                        rowWrapper: true,
                                        typeTitle: true,
                                    })}
                                >
                                    <span
                                        className={cx({
                                            metric: true,
                                            emptyMetric: this.props.wordCount === 0,
                                            badMetric:
                                               (this.props.wordCount > 0 &&
                                                this.props.wordCount < 300) ||
                                                this.props.wordCount > 800,
                                            goodMetric:
                                                this.props.wordCount > 300 &&
                                                this.props.wordCount < 800,
                                        })}
                                    >
                                        {this.props.wordCount}
                                    </span>
                                    <div
                                        className={cx({
                                            rowLabel: true,
                                            disabled: this.props.wordCount === 0
                                        })}
                                    >
                                        Word count</div>
                                    <div className={cx('weirdRowWrapThing', 'pushRight')}>
                                        <div className={styles.chevronWrap}>
                                            <FontAwesomeIcon
                                                icon={
                                                    this.state
                                                        .wordCountSectionIsOpen
                                                        ? faChevronUp
                                                        : faChevronDown
                                                }
                                            />
                                        </div>
                                    </div>
                                </div>
                                {this.state.wordCountSectionIsOpen ? (
                                    <div
                                        className={cx({
                                            extraData: true,
                                            explainer: true,
                                        })}
                                    >
                                        Jobs vary, but top scoring ads are between
                                        300 and 800 words, balancing information
                                        with brevity.
                                    </div>
                                ) : null}
                            </div>
                            <div className={styles.separator}></div>
                            <div
                                className={cx('rowWrapper', 'typeTitle', 'extraPadding')}
                            >
                                <span
                                    className={cx({
                                        metric: true,
                                        bullshit: true,
                                        emptyMetric:
                                            this.props.countCorporate === 0,
                                    })}
                                >
                                        {this.props.countCorporate}
                                    </span>
                                <div
                                        className={cx({
                                            rowLabel: true,
                                            bold: this.props.countCorporate > 0,
                                            disabled: this.props.countCorporate === 0
                                        })}
                                    >
                                        Buzzword Bingo</div>
                                <div className={cx('weirdRowWrapThing', 'pushRight')}>
                                    <Tooltip
                                        html={this.buzzwordPopover()}
                                        interactive
                                        position={'bottom'}
                                        theme={'light'}
                                        className={styles.pushRight}
                                    >
                                        <FontAwesomeIcon
                                            icon={faLightbulbOn}
                                            className={styles.blueIcon}
                                        />
                                    </Tooltip>
                                </div>
                            </div>
                            <div
                                className={cx('rowWrapper', 'typeTitle', 'extraPadding')}
                            >
                                <span
                                    className={cx({
                                        metric: true,
                                        acronyms: true,
                                        emptyMetric:
                                            this.props.capsCount === 0,
                                    })}
                                >
                                    {this.props.capsCount}
                                </span>
                                <div
                                    className={cx({
                                        rowLabel: true,
                                        bold: this.props.capsCount > 0,
                                        disabled: this.props.capsCount === 0
                                    })}
                                >
                                        Acronyms</div>
                                <div className={cx('weirdRowWrapThing', 'pushRight')}>
                                    <Tooltip
                                        html={this.acronymsPopover()}
                                        interactive
                                        position={'bottom'}
                                        theme={'light'}
                                        className={styles.pushRight}
                                    >
                                        <FontAwesomeIcon
                                            icon={faLightbulbOn}
                                            className={styles.blueIcon}
                                        />
                                    </Tooltip>
                                </div>
                            </div>
                        </div>
                        {!this.props.user.userId ? (
                            <div className={styles.padlockSection}>
                                <FontAwesomeIcon
                                    icon={faLock}
                                    className={styles.deactivatedLock}
                                />
                                <div>Want to see the full score?</div>
                                <a
                                    className={styles.signupButton}
                                    href="https://www.beapplied.com/job-description-analysis-tool-signup"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <Button>Sign up</Button>
                                </a>
                            </div>
                        ) : null}
                    </div>
                </div>

                {this.props.user.userId ? (<div className={styles.infoBox}>
                    <h3>Based on research and powered by science</h3>
                    <p>These scores and suggestions are based on Danielle Gaucher, Justin Friesen (University of Waterloo), and Aaron C. Kay’s research (Duke University) published by the American Psychological Association. <br /><u>No</u> AI is used for this tool.</p>
                </div>) : null}
            </div>
        )
    }
}

AnalysisBox.propTypes = {
    maleCount: PropTypes.number,
    femaleCount: PropTypes.number,
    maleWords: PropTypes.array,
    femaleWords: PropTypes.array,
    score: PropTypes.number,
    bias: PropTypes.exact({
        score: PropTypes.number,
        description: PropTypes.string
    }),
    readingEase: PropTypes.number,
    mustCount: PropTypes.number,
    capsCount: PropTypes.number,
    editorEmpty: PropTypes.bool,
    countCorporate: PropTypes.number,
    countExperience: PropTypes.number,
    countEducation: PropTypes.number,
    wordCount: PropTypes.number,
    inclusionScore: PropTypes.number,
    conversionScore: PropTypes.number,
}

export default AnalysisBox
